export default __webpack_public_path__ + "static/media/stl_upper_fill.4f1c9373.svg";